import styles from "./profile.module.css";
import { BiExit } from "react-icons/bi";
import { useState, useEffect, useRef, useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { Navigate, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import Modal from "./modal/Modal";
import "./WalletDetails.scss";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import UserContext from "context/UserContext";
import pic from "../../assets/images/icons8-user-96.png";
import { CgProfile } from "react-icons/cg";
import { BsCardChecklist } from "react-icons/bs";
import { BsWallet2 } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import CartItemsContext from "context/ShoppingCartItems";

import Loader from "utils/Loader";

function Profile() {
  const [img, setimg] = useState("");
  const auth = useContext(WithAuthentication);
  const { updateShoppingList } = useContext(CartItemsContext);
  const history = useNavigate();
  const [updater, setUpdater] = useState(false);
  const { setUserInfo, setIsLoading } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [activeButton, setActiveButton] = useState(-1);

  const { namaLable, setNameLable } = useState([
    { lb: "نام و نام خانوادگس" },
    { lb: "کدملی" },
  ]);

  let hash = useLocation();

  useEffect(() => {
    hash.hash == "#orders" && setActiveButton(2);
  }, []);

  const [profileValue, setProfileValue] = useState({
    id: "",
    fullname: "",
    codemeli: "",
    tell: "",
    mobile: "",
    path: null,
    address: "",
  });
  // console.log("auth", auth);
  // console.log("user!!", user);
  // console.log("profilevalue", profileValue);
  useEffect(() => {
    async function loadPage() {
      //setIsLoading(true);
      // let id = 1;
      // let id = 117;
      let myFormData = new FormData();
      myFormData.append("conditions", `users.id/=/${auth.userInfo.id}`);
      myFormData.append("tbl_name", `left join,files,profile_pic_file_id,id`);
      await axios
        .post("http://old-sabadib.tatdemo.ir/api/Find_users", myFormData)
        .then(function ({ data }) {
          // console.log(data[0].codemeli);
          setProfileValue({
            id: data[0].id,
            fullname: data[0].fullname,
            codemeli: data[0].codemeli,
            tell: data[0].tell,
            mobile: data[0].mobile,
            path: data[0].path,
            address: data[0].address,
          });
          setUserInfo({
            id: data[0].id,
            fullname: data[0].fullname,
            codemeli: data[0].codemeli,
            tell: data[0].tell,
            mobile: data[0].mobile,
            path: data[0].path,
            address: data[0].address,
          });
          setIsLoading(false);
        })
        .catch(function (error) {
          console.log(error);
        });
      setLoading(false);
    }
    loadPage();
  }, [updater]);
  async function logOOt() {
    await auth.logout();
    updateShoppingList();
    history("/");
  }
  if (!auth.isLogged) {
    history("/");
  }
  return (
    <>
      {loading && <Loader></Loader>}
      <div
        dir="rtl"
        className={`d-flex ${styles.containerMain} justify-content-evenly profile`}
      >
        <div className="col-11 col-md-10 col-lg-12">
          <div dir="rtl " className={styles.boxcol}>
            <div className="d-flex parent-prof">
              <div className="d-flex justify-content-between box-container">
                <div></div>
                <span className="lbl-prof">
                  <label>نام </label>
                </span>
                <span className="prof-val">{profileValue.fullname}</span>
              </div>
              <div className="d-flex justify-content-between box-container mr-2">
                <div></div>
                <span className="lbl-prof">
                  <label>کدملی </label>
                </span>
                <span className="prof-val">{profileValue.codemeli}</span>
              </div>
            </div>
            <div className="d-flex parent-prof ">
              <div className="d-flex justify-content-between box-container">
                <div></div>
                <span className="lbl-prof">
                  <label>تلفن </label>
                </span>
                <span className="prof-val">{profileValue.tell}</span>
              </div>
              <div className="d-flex justify-content-between box-container mr-2">
                <div></div>
                <span className="lbl-prof">
                  <label>موبایل </label>
                </span>
                <span className="prof-val">{profileValue.mobile}</span>
              </div>
            </div>
            <div className="d-flex parent-prof ">
              <div className="d-flex justify-content-between box-addres">
                <div></div>
                <span className="lbl-addres">
                  <label>ادرس </label>
                </span>
                <span className="prof-val-addres">{profileValue.address}</span>
              </div>
            </div>
          </div>
          <div
            className={styles.editInfo}
            style={{ padding: " 100px 6% 20px" }}
          >
            <div className=" mx-3 mt-3">
              <Modal
                setIsLoading={setIsLoading}
                updater={updater}
                setUpdater={setUpdater}
                profileValue={profileValue}
                EditUser={setProfileValue}
              />
            </div>
            {auth.isLogged && (
              <div
                className="text-dark  d-flex align-items-center mx-1"
                style={{
                  width: "75px",
                  cursor: "pointer",
                  // fontSize: "14px",
                  borderRadius: "7px",
                  padding: "0 5px",
                  textAlign: "center",
                }}
                onClick={logOOt}
              >
                <span className="text-decoration-none ">
                  <BiExit />
                  <span style={{ color: "red" }}>خروج</span>
                </span>
              </div>
            )}
          </div>
        </div>

        {/* <div
        style={{
          textAlign: "-webkit-center",
          marginTop: "20px"
          // marginRight: "30px",
        }}
      >
        <div className="circle1">
          <div className="triangle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="117.734"
              height="144.88"
              viewBox="0 0 117.734 144.88"
            >
              <path
                id="Path_369"
                data-name="Path 369"
                d="M57.629,142.891,115.258,17.327,108.1,12.451,97.687,8.233S72.851,0,59.578,0C30.763,0,0,17.327,0,17.327Z"
                transform="matrix(-1, -0.017, 0.017, -1, 115.24, 144.88)"
                fill="#fe7669"
              />
            </svg>
            <div className="circle2">
              <div className="rate">360 امتیاز</div>
            </div>
          </div>
        </div>
      </div> */}
      </div>
    </>
  );
}

export default Profile;
